import React from "react";
import SignUp from "../components/SignUp/SignUp";

export default function SignUpPage() {
  return (
    <div>
      <SignUp />
    </div>
  );
}
